import { render, staticRenderFns } from "./AbkNewPageForm.vue?vue&type=template&id=2432ba30&scoped=true&"
import script from "./AbkNewPageForm.vue?vue&type=script&lang=js&"
export * from "./AbkNewPageForm.vue?vue&type=script&lang=js&"
import style0 from "./AbkNewPageForm.vue?vue&type=style&index=0&id=2432ba30&scoped=true&lang=scss&"
import style1 from "./AbkNewPageForm.vue?vue&type=style&index=1&id=2432ba30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2432ba30",
  null
  
)

export default component.exports